import { ChevronDown, Target, Shield, Users, CalendarCheck, BicepsFlexed } from "lucide-react";
import { Button } from "@/components/ui/button";

export const HeroSection = () => {
  const scrollToEvents = () => {
    const element = document.querySelector("#eventi");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section 
      data-testid="hero-section" 
      /* AGGIUNTO: padding bottom (pb-) per distanziare le stats dal bordo */
      className="hero-section relative min-h-screen flex items-center bg-tactical-bg hex-pattern overflow-hidden pb-10"
    >
      {/* Background Gradient Overlay: 
          Rafforzato per creare la transizione graduale verso la sezione successiva 
      
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-tactical-bg/40 to-tactical-bg z-0" /> */}
      
      {/* Sfumatura finale per transizione morbida tra sezioni */}
      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-tactical-bg to-transparent z-[1]" />

      {/* Scanlines */}
      <div className="scanlines absolute inset-0 z-0 opacity-20" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="max-w-4xl">
          {/* Status indicator */}
          <div className="flex items-center gap-3 mb-8 opacity-0 animate-fade-in-up">
            <div className="status-indicator bg-tactical-primary" />
            <span className="font-mono text-xs text-tactical-text-muted tracking-widest uppercase">
              Associazione Sportiva Dilettantistica riconosciuta CONI
            </span>
          </div>

          {/* Logo and Main Title */}
          <div className="flex items-center gap-6 mb-6 opacity-0 animate-fade-in-up animate-delay-100">
            <img
              src="/logo.png"
              alt="Ghost Division Logo"
              className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 object-contain drop-shadow-2xl" 
            />

            <h1
              data-testid="hero-title"
              /* Nota: ho mantenuto il tuo !text-[#444444] ma su sfondo nero 
                 potrebbe servire un leggero bagliore per la leggibilità */
              className="font-heading sm:text-5xl md:text-6xl lg:text-7xl uppercase glitch-text font-bold text-4xl tracking-wider !text-[#444444]"
            >
              GHOST
              <br />
              <span className="text-tactical-primary">DIVISION</span>
            </h1>
          </div>

          {/* Subtitle */}
          <p
            data-testid="hero-subtitle"
            className="font-body text-lg sm:text-xl text-tactical-text-muted max-w-2xl mb-8 opacity-0 animate-fade-in-up animate-delay-200"
          >
            Elite Softair Team. Addestramento tattico, missioni realistiche e 
            spirito di squadra. Unisciti alle nostre operazioni o sfidaci sul campo.
          </p>

          {/* CTA Buttons - Ridotto mb-16 a mb-10 per avvicinare le stats */}
          <div className="flex flex-wrap gap-3 mb-10 opacity-0 animate-fade-in-up animate-delay-300">
            <Button
              data-testid="hero-cta-events"
              onClick={scrollToEvents}
              className="btn-tactical bg-tactical-primary text-black font-heading font-bold uppercase tracking-widest px-8 py-6 text-sm hover:bg-white"
            >
              Eventi
            </Button>
            <Button
              data-testid="hero-cta-trial"
              variant="outline"
              onClick={() => document.querySelector("#contatti")?.scrollIntoView({ behavior: "smooth" })}
              className="border-tactical-primary text-tactical-primary font-heading font-bold uppercase tracking-widest px-8 py-6 text-sm transition-all hover:bg-tactical-primary hover:text-black bg-transparent"
            >
              Prenota una Prova
            </Button>

            <Button
              data-testid="hero-cta-team"
              variant="outline"
              onClick={() => document.querySelector("#chi-siamo")?.scrollIntoView({ behavior: "smooth" })}
              className="border-tactical-primary text-tactical-primary font-heading font-bold uppercase tracking-widest px-8 py-6 text-sm transition-all hover:bg-tactical-primary hover:text-black bg-transparent"
            >
              Il Team
            </Button>
          </div>

          {/* Stats Icons - Centrate e bilanciate */}
          <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto md:mx-0 opacity-0 animate-fade-in-up animate-delay-400 mt-4">
            <div className="text-center px-2">
              <CalendarCheck className="w-5 h-5 text-tactical-primary mx-auto mb-2" />
              <div className="font-heading font-bold text-xl text-tactical-text">10+</div>
              <div className="font-mono text-[10px] text-tactical-text-muted uppercase tracking-tighter">
                Eventi Annuali
              </div>
            </div>
  
            <div className="text-center px-2 border-x border-tactical-primary/10">
              <Users className="w-5 h-5 text-tactical-primary mx-auto mb-2" />
              <div className="font-heading font-bold text-xl text-tactical-text">10+</div>
              <div className="font-mono text-[10px] text-tactical-text-muted uppercase tracking-tighter">
                Operatori
              </div>
            </div>
  
            <div className="text-center px-2">
              <BicepsFlexed className="w-5 h-5 text-tactical-primary mx-auto mb-2" />
              <div className="font-heading font-bold text-xl text-tactical-text">10+</div>
              <div className="font-mono text-[10px] text-tactical-text-muted uppercase tracking-tighter">
                Anni
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};